import { useEffect } from "react";

// Scrolls to the URL #hash after the SPA renders (direct visits / sitelinks).
export function useHashScroll() {
  useEffect(() => {
    let userMoved = false;
    const stop = () => { userMoved = true; };
    const go = () => {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (!id || userMoved) return;
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ block: "start", behavior: "auto" });
    };
    window.addEventListener("wheel", stop, { passive: true, once: true });
    window.addEventListener("touchstart", stop, { passive: true, once: true });
    window.addEventListener("keydown", stop, { once: true });
    const timers = [60, 500, 1200].map((ms) => setTimeout(go, ms));
    return () => {
      timers.forEach(clearTimeout);
      window.removeEventListener("wheel", stop);
      window.removeEventListener("touchstart", stop);
      window.removeEventListener("keydown", stop);
    };
  }, []);
}
